import { getCopy } from "@mobile/app/config/appCopy";

import type { SupportLanguage } from "../appModel";
import type { WebAudioUnitType } from "./webAudioUnit";

export function getWebAudioRewardCopy(language: SupportLanguage, unitType: WebAudioUnitType) {
  const copy = getCopy(language);
  const unitLabel = unitType === "scenarioVocabulary"
    ? copy.vocabularyAudioLabel
    : unitType === "scenarioMissions"
      ? copy.missionAudioLabel
      : copy.sectionAudioLabel;
  return {
    action: copy.audioUnlockPromptConfirmLabel,
    body: copy.audioUnlockPromptMessageTemplate.replace("{unitLabel}", unitLabel),
    title: copy.audioUnlockPromptTitle,
  };
}
